import { render, staticRenderFns } from "./AdmisionDepurarHabilitadoEscrita.vue?vue&type=template&id=ff5fee52"
import script from "./AdmisionDepurarHabilitadoEscrita.vue?vue&type=script&lang=js"
export * from "./AdmisionDepurarHabilitadoEscrita.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports